export default interface AuditLogAuth {
    when: string;
    what:string;
    how: string;
  remoteIp: string;
  who: string;
  userId: string;
  }
  
const auditLogInitialValue: AuditLogAuth = {
    when: String(),
  what: String(),
  how: String(),
  remoteIp: String(),
  who: String(),
  userId: String()
  };

enum AuditTypes {
  Crud = 'Crud', 
  Logger = 'Logger',
  Auth = 'Auth',
  Clone = 'Clone',
  Email = 'Email',
  Download = 'Download',
  ViewProduct = 'ViewProduct'
}
  
export { AuditTypes, auditLogInitialValue };
  